import { createSlice } from "@reduxjs/toolkit";
import { Location } from "../global";

interface MySliceState {
    bg: number, lang: string, morning: boolean, dialogOpen: boolean, logOpen: number, homeReady: boolean,
    height: number, mobileOpened: boolean, userType: boolean, language: 'en' | 'ar',
    locations: Location[] | null, selectedLocation: Location | null, selectedInterest: string,
    selectedCat: number, phone: string,
}
const sysSlice = createSlice({
    name: "sys",
    initialState: { 
        bg: 0, lang: "ltr", dialogOpen: false, logOpen: 7, homeReady:false, height:200, mobileOpened:false, userType:true,
        language: typeof window !== "undefined" ? localStorage.getItem("preferredLanguage") ?? "en" : "en",
        locations: null, selectedLocation: null, selectedCat: 0, morning: true, phone: "",
        selectedInterest: typeof window !== "undefined" ? localStorage.getItem("salonCategory") ?? "Ladies" : "none",
    } as MySliceState,
    reducers: {
        setLangMy: (state, action) => { state.language = action.payload },
        setHeight: (state, action) => { state.height = action.payload },
        setBg: (state, action) => { state.bg = action.payload },
        setLang: (state, action) => { state.lang = action.payload },
        setDay: (state) => { state.morning = true },
        setNight: (state) => { state.morning = false },
        logAction: (state, action) => { state.logOpen = action.payload },
        setDialog: (state, action) => { state.dialogOpen = action.payload },
        setMobile: (state, action) => { state.mobileOpened = action.payload },
        setUserType: (state, action) => { state.userType = action.payload },
        setLocation: (state, action) => { state.locations = action.payload },
        setPhone: (state, action) => { state.phone = action.payload },
        setSelectedLocation: (state, action) => { state.selectedLocation = action.payload },
        setSelectedInterest: (state, action) => { state.selectedInterest = action.payload },
        setSelectedCat: (state, action) => { state.selectedCat = action.payload },
    }
});

export const {
    setHeight, setSelectedCat, setSelectedInterest, setSelectedLocation, setLocation, setLangMy, 
    setUserType, setMobile, logAction, setBg, setLang, setDay, setNight, setDialog, setPhone
} = sysSlice.actions;
export default sysSlice;